import { MsgBusEvents } from "../common/events";
import { logger } from "./logger";

export type SubscriptionToken = string;

export interface MessageBusType {
  publish: MessageBusCallback;
  subscribe: (topic: string, handler: MessageBusCallback) => SubscriptionToken;
  unsubscribe: (unsubscribeToken: SubscriptionToken) => void;
}

export type MessageBusCallback<Payload = unknown> = (
  topic: string,
  payload: Payload,
) => void;

export class MessageBus {
  private subscriptions: Set<SubscriptionToken> = new Set();
  // START & STOP subscriptions must always be active
  // if the higher component decides to close the widget and later reopen it.
  private excludeTopicsFromDispose: string[] = [
    MsgBusEvents.START,
    MsgBusEvents.STOP,
  ];
  constructor(private readonly mb: MessageBusType) {}

  publish<Payload = unknown>(topic: string, payload: Payload) {
    logger.log(`[${MessageBus.name}] Publishing message: `, {
      topic,
      payload,
    });
    this.mb.publish(topic, payload);
  }

  subscribe(topic: string, cb: MessageBusCallback): SubscriptionToken | void {
    const token = this.mb.subscribe(topic, cb);
    if (this.excludeTopicsFromDispose.includes(topic)) return;
    this.subscriptions.add(token);
    return token;
  }

  dispose() {
    this.subscriptions.forEach((token) => this.mb.unsubscribe(token));
  }

  disposeTopic(topic: string) {
    this.mb.unsubscribe(topic);
    this.subscriptions.delete(topic);
  }
}
